import { apiRequest } from "./client";

// JSON-значение, которое может лежать под любым ключом settings.
export type SettingValue =
  | null
  | boolean
  | number
  | string
  | SettingValue[]
  | { [key: string]: SettingValue };

export interface SettingsResponse {
  settings: Record<string, SettingValue>;
}

export interface SettingsPatchPayload {
  updates: Record<string, SettingValue>;
}

// Конфиг DOM-селекторов расширения (см. backend ExtensionSelectors).
export interface ExtensionClientSelectors {
  compose_root?: string | null;
  to_field?: string | null;
  subject_field?: string | null;
  body?: string | null;
  send_button?: string | null;
  attachment_chip?: string | null;
  attachment_remove?: string | null;
}

export type MailClient = "gmail" | "outlook_web" | "yandex";

export interface ExtensionSelectors {
  version: number;
  ttl_seconds: number;
  clients: Record<MailClient, ExtensionClientSelectors>;
}

export const SELECTORS_KEY = "extension.selectors";

// Настраиваемые пороги аналитики (см. backend AnalyticsThresholds, PRD §7.4).
export interface AnalyticsThresholds {
  notification_threshold_pages: number;
  counted_page_min_active_seconds: number;
  counted_page_min_visible_percent: number;
  notification_delay_min_seconds: number;
  notification_delay_max_seconds: number;
  inactivity_timeout_seconds: number;
}

export const THRESHOLDS_KEY = "analytics.thresholds";

export const ANALYTICS_THRESHOLDS_DEFAULTS: AnalyticsThresholds = {
  notification_threshold_pages: 4,
  counted_page_min_active_seconds: 5,
  counted_page_min_visible_percent: 25,
  notification_delay_min_seconds: 60,
  notification_delay_max_seconds: 180,
  inactivity_timeout_seconds: 30,
};

// Плавающая CTA в viewer (PRD §6.2). value — E.164-телефон или http(s)-URL.
// Хранится в settings под ключом ``viewer.cta``; ``null`` = кнопка отключена.
export type CtaKind = "phone" | "url";

export interface ViewerCta {
  kind: CtaKind;
  value: string;
}

export const CTA_KEY = "viewer.cta";

// Privacy URL (PRD §13.3). Хранится в settings под ``viewer.privacy_url``.
// null / пустая строка — viewer покажет ссылку на дефолт `/privacy`.
export const PRIVACY_URL_KEY = "viewer.privacy_url";

export const settingsApi = {
  get: () => apiRequest<SettingsResponse>("/settings"),
  patch: (payload: SettingsPatchPayload) =>
    apiRequest<SettingsResponse>("/settings", { method: "PATCH", body: payload }),
  getEffectiveSelectors: () =>
    apiRequest<ExtensionSelectors>("/extension/config"),
};
